import { TARGET_ALL, TARGET_MAIL, TARGET_REMOTE_NOTIFICATION } from 'entities/user_notice/constants/target_type'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import 'styles/views/user_notice/mails/common/lib/destinations-field.scss'
import { initialize } from './actions'
import App from './components/app'
import store from './store'

export default class DestinationsField extends Component {
  constructor(props) {
    super(props)

    store.dispatch(
      initialize(props.paramKey, props.recruiterDestinationCandidateTarget, props.tagDestinationCandidateTarget)
    )
  }

  render() {
    const { className, buttonClassName, summaryClassName, recruiterIds, tagIds, specialTypes, onChange } = this.props

    return (
      <Provider store={store}>
        <App
          className={className}
          buttonClassName={buttonClassName}
          summaryClassName={summaryClassName}
          recruiterIds={recruiterIds}
          tagIds={tagIds}
          specialTypes={specialTypes}
          onChange={onChange}
        />
      </Provider>
    )
  }
}

DestinationsField.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  summaryClassName: PropTypes.string,
  paramKey: PropTypes.string.isRequired,
  recruiterDestinationCandidateTarget: PropTypes.oneOf([TARGET_ALL, TARGET_MAIL, TARGET_REMOTE_NOTIFICATION])
    .isRequired,
  tagDestinationCandidateTarget: PropTypes.oneOf([TARGET_ALL, TARGET_MAIL, TARGET_REMOTE_NOTIFICATION]).isRequired,
  recruiterIds: PropTypes.arrayOf(PropTypes.number),
  tagIds: PropTypes.arrayOf(PropTypes.number),
  specialTypes: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired
}

DestinationsField.defaultProps = {
  className: null,
  buttonClassName: null,
  summaryClassName: null,
  recruiterIds: [],
  tagIds: [],
  specialTypes: []
}
